import { render, staticRenderFns } from "./ChatEditor.vue?vue&type=template&id=1c88154a&scoped=true&"
import script from "./ChatEditor.vue?vue&type=script&lang=js&"
export * from "./ChatEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c88154a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c88154a')) {
      api.createRecord('1c88154a', component.options)
    } else {
      api.reload('1c88154a', component.options)
    }
    module.hot.accept("./ChatEditor.vue?vue&type=template&id=1c88154a&scoped=true&", function () {
      api.rerender('1c88154a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamInbox/ChatEditor.vue"
export default component.exports